import templateUrl from "webforms/formio/form-submission.htm";
import controller from "webforms/formio/form-submission.controller";

export default {
  require: {
    //container: '^retailerContainer'
  },
  bindings: {
    disableQueryString: "<?",
    formioId: "@",
    submissionId: "@",
    formData: "<?",
    successMessage: "@",
    successRedirect: "@",
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
